import { HelperLut } from './../volume-rendering/helpers/helpers.lut';
import { Injectable, OnDestroy } from '@angular/core';
import { SceneService } from './scene.service';
import { OrthographicCamera, WebGLRenderer, PerspectiveCamera } from 'three';
import { Subject } from 'rxjs';
import { CanvasService } from './canvas.service';

// TODO: move domElement related to CanvasService
@Injectable()
export class RendererService implements OnDestroy {
  // public camera: OrthographicCamera | undefined | PerspectiveCamera = new PerspectiveCamera();
  public camera: OrthographicCamera | undefined | PerspectiveCamera;
  // public lut = new HelperLut(this.canvas.domElement);
  private verbose = 0;
  public renderer = new WebGLRenderer({
    canvas: this.canvas.domElement,
    antialias: true,
    // alpha: true,
  });
  private subject = new Subject<void>();
  readonly render$ = this.subject.asObservable();
  private isPushbasedRender = true;
  constructor(
    private sceneService: SceneService,
    private canvas: CanvasService,
  ) {
    // console.log(this.lut);

    this.canvas.size$.subscribe(
      b => {
        const currentSize = this.renderer.getSize();
        if (b.size.x !== currentSize.width || b.size.y !== currentSize.height) {
          this.renderer.setSize(b.size.x, b.size.y);
          this.render();
        }
      },
      e => console.error(e),
    );
    if (this.isPushbasedRender) {
      this.render$.subscribe(
        () => {
          this.doRender();
        },
        e => console.error(e),
      );
    } else {
      this.animation();
    }
  }
  private doRender() {
    if (this.camera === undefined) {
      if (this.verbose > 0) {
        console.warn(
          'Failed to render:\ncamera: ',
          this.camera,
          '\ncanvas',
          this.canvas,
          '\nrenderer:',
          this.renderer,
          '\n',
        );
      }
      return;
    }
    this.renderer.render(this.sceneService.scene, this.camera);
  }
  setCamera(camera: OrthographicCamera | PerspectiveCamera) {
    this.camera = camera;
  }
  private animation() {
    requestAnimationFrame(() => this.animation());
    this.doRender();
  }
  render() {
    this.subject.next();
  }
  get domElement() {
    return this.renderer.domElement;
  }
  ngOnDestroy() {
    this.subject.complete();
  }
}
